import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const location   = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/authentication/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;